import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export interface IGetPackageResponse {
  package?: IPackage;
}

export class GetPackageService {
  public static getPackage(packageLuid: string): Promise<IGetPackageResponse> {
    return makeJsonRestApiRequest<void, IGetPackageResponse>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'GET',
        endpoint: `${PACKAGES_PATH}/${packageLuid}`,
      },
      request: null,
    });
  }
}
